export default "__VITE_ASSET__Dp6K2r34__"